<template>
    <b-row class="w-100 no-gutters py-2 justify-content-center align-self-center">
        <b-card-body :key="'report'">
            <div v-if="ReportParameters != undefined" v-for="(fieldSet, fieldSetIndex) in ReportParameters.FieldSets" class="pb-1" @drop="emitDrop($event, fieldSet)">
                <!-- @mouseover="hoverFieldSet('field' + fieldSetIndex)" @mouseleave="stopHoverFieldSet('field' + fieldSetIndex)" -->
                <b-row :key="'field' + fieldSetIndex" class="position-relative p-3 m-3 border border-gray-middle-dark h-100 rounded" @dragover="onFieldSetOver($event, fieldSet, fieldSetIndex)" :class="isGhostFieldSet(fieldSet) ? 'ghostFieldSet' : ''">
                    <b-icon-gear 
                            v-if="IsEditor && hoverTimeout != null && hoverTimeout?.find(u => u.key == 'field' + fieldSetIndex)?.value == true"
                            class="position-absolute h2" 
                            style="opacity: 1 !important; pointer-events: all; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 5rem; cursor: pointer; z-index: 10;"  
                            @click="changeParameter(fieldSet)" />
                    <div class="w-100" :style="IsEditor && hoverTimeout != null && hoverTimeout?.find(u => u.key == 'field' + fieldSetIndex)?.value == true ? 'opacity: 50%' : ''">
                        <template v-if="fieldSet.CheckboxToggle != null">
                            <b-row >
                                <b-col style="margin-top: -27px;" class="bg-gray-light px-1 position-absolute w-auto d-flex align-items-center">
                                    <b-form-checkbox style="margin-left: 5px; vertical-align: middle;" class="mb-0" v-model="fieldSet.CheckboxToggle" plain>{{ fieldSet.Title }}</b-form-checkbox>
                                </b-col>
                            </b-row>
                        </template>
                        <template v-else>
                            <b-col style="margin-top: -27px; margin-left: 5px;"
                                class="bg-gray-light px-1 position-absolute w-auto">
                                {{ fieldSet.Title }}
                            </b-col>
                        </template>
                        <div v-if="checkBoxToggleDatas(fieldSet) && !isGhostFieldSet(fieldSet)">
                            <template v-if="fieldSet.Layout != null && fieldSet.parseLayout(String(fieldSet.Layout)) == 'Column'">
                                <b-row cols="auto" style="min-height: 30px;">
                                    <!-- @mouseover="hoverParameter('row' + parameter.Name + index, 'field' + fieldSetIndex)" @mouseleave="stopHoverParameter('row' + parameter.Name + index)" -->
                                    <b-col v-for="(parameter, index) in fieldSet.Parameters.filter(u => u.Type != 'Hidden')"  :key="'row' + parameter.Name + index" class="d-flex justify-content-center align-items-center p-2" @drop="emitDrop($event, parameter)" @dragover="onParameterOver($event, parameter, index)">
                                        <ParametersItems :Parameter="parameter"
                                            :IsEditor="IsEditor"
                                            :ReportParameters="ReportParameters"
                                            @change-parameter="openChangeModal"></ParametersItems>
                                    </b-col>
                                </b-row>
                            </template>
                            <template v-else>
                                <!-- @mouseover="hoverParameter('row' + parameter.Name + index, 'field' + fieldSetIndex)" @mouseleave="stopHoverParameter('row' + parameter.Name + index)" -->
                                <b-row v-for="(parameter, index) in fieldSet.Parameters.filter(u => u.Type != 'Hidden')" :key="'row' + parameter.Name + index" class="position-relative" style="min-height: 30px;" @drop="emitDrop($event, parameter)" @dragover="onParameterOver($event, parameter, index)">
                                    <b-col class="d-flex justify-content-center align-items-center p-2">
                                        <ParametersItems :Parameter="parameter"
                                            :IsEditor="IsEditor"
                                            :ReportParameters="ReportParameters"
                                            @change-parameter="openChangeModal"></ParametersItems>
                                        <div v-if="parameter.Type === 'Number'" class="pl-3 text-center">{{ parameter.Label }}</div>
                                    </b-col>
                                </b-row>
                            </template>
                        </div>
                    </div>
                </b-row>
            </div>
        </b-card-body>
    </b-row>
</template>

<script lang="ts">
    import { Prop, Vue } from 'vue-property-decorator';
    import Component, { mixins } from 'vue-class-component';
    import { ThemeUtils, LinkUtils } from "@/components/commons/Utils";
    import ParametersItems from './ParametersItems.vue'
    import FieldSet from './FieldSet';
    import Parameter from './Parameter';
    import ReportParameters from './ReportParameters';
    
    /**
     * Affichage du corp du rapport
     */
    @Component({
        components: {
            ParametersItems
        }
    })
	export default class ReportParameter extends mixins(ThemeUtils, LinkUtils, Vue){
        /** Variant de couleur à appliquer sur le composant */
		@Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop({default: () => new ReportParameters()})
        public ReportParameters!: ReportParameters;

        @Prop()
        public FunctionRegistry!: Map<string, Function>;

        @Prop({default: () => false})
        public IsEditor!: boolean;

        public hoverTimeout: {timeoutId: number, key: string, value: boolean}[] = [];
        public isHoverParameter: boolean = false;      

        public selectedFieldSetIndex: number = -1;
        public selectedParameterIndex: number = -1;

        private checkBoxToggleDatas(FieldSet: FieldSet){
            if(FieldSet !== null){
                // S'il y a des données dans CheckBoxToggle
                if (FieldSet.CheckboxToggle != null) {
                    // Si les Parameters à l'intérieur ont des données
                    if (FieldSet.Parameters.find(u => u.HasValue) !== undefined) {
                        // return true;
                        return FieldSet.CheckboxToggle;
                    } else {
                        // S'il n y a pas de données return true pour afficher le message de données non disponible
                        FieldSet.CheckboxToggle = false;
                        return true;
                    }
                }
                else return true
            }
            return false;
        }

        /**
         * Retourne true si la cible est un FieldSet Temporaire
         * @param fieldSet 
         */
        private isGhostFieldSet(fieldSet: FieldSet) : boolean {
            return fieldSet instanceof FieldSet && fieldSet.equalsFieldSet();
        }

        /**
         * Ajoute la class selectedGhostFieldSet à l'élément sélectionné
         * Sinon retire la class a tous les élements
         * @param event 
         * @param fieldSet 
         * @param fieldSetIndex 
         */
        private onFieldSetOver(event, selectedItem: FieldSet, fieldSetIndex: number){
            let target = event.target as HTMLElement;

            let functionConstruct: any = Reflect.construct(this.FunctionRegistry.get(event.dataTransfer.getData('targetDrag')), ['']);
            let functionName: string = functionConstruct.getClassName();

            let ghostSelected: HTMLElement = document.querySelector('.selectedGhostFieldSet') as HTMLElement;

            if(ghostSelected)
                ghostSelected.classList.remove("selectedGhostFieldSet");

            if(target && this.isGhostFieldSet(selectedItem)){
                if (!target.classList.contains('selectedGhostFieldSet'))
                    target.classList.add('selectedGhostFieldSet');
                
                event.preventDefault();
                this.selectedFieldSetIndex = fieldSetIndex;
            } else if(target && functionName === 'Parameter'){
                if(this.selectedFieldSetIndex != fieldSetIndex){
                    functionConstruct.replaceGhost(this.ReportParameters, fieldSetIndex);
                    this.selectedFieldSetIndex = fieldSetIndex;
                }
            } else {
                this.selectedFieldSetIndex = -1;
                event.stopPropagation();
            }
        }
      
        /**
         * Change la class du Parameter Over
         * @param event 
         * @param selectedParameter 
         */
        private onParameterOver(event, selectedParameter: Parameter, parameterIndex: number){
            let target = event.target as HTMLElement;

            let ghostSelected: HTMLElement = document.querySelector('.selectedGhostParameter') as HTMLElement;

            if(ghostSelected)
                ghostSelected.classList.remove("selectedGhostParameter");

            if(target && this.isGhostParameter(selectedParameter)){
                if (!target.classList.contains('selectedGhostParameter'))
                    target.classList.add('selectedGhostParameter');

                    this.selectedParameterIndex = parameterIndex;
                event.preventDefault();
            } else {
                this.selectedParameterIndex = -1;
                event.stopPropagation();
            }
        }

         /**
          * Retourne true si la cible est un Parameter Temporaire
          * @param parameter 
          */
        private isGhostParameter(parameter: Parameter) : boolean {
            return parameter instanceof Parameter && parameter.equalsParameter();
        }

        // private hoverFieldSet(objectId: string){
        //     if(this.IsEditor && !this.hoverTimeout.find(u => u.key == objectId) && !this.isHoverParameter){
        //         this.hoverTimeout.push({timeoutId: setTimeout(() => {
        //             Vue.nextTick(() => {
        //                 this.hoverTimeout.find(u => u.key == objectId).value = true;
        //             });
        //         }, 1000), key: objectId, value: false});
        //     }
        // }

        // private stopHoverFieldSet(objectId: string){
        //     if(this.IsEditor && this.hoverTimeout.find(u => u.key == objectId)){
        //         let index = this.hoverTimeout.findIndex(u => u.key == objectId);
        //         clearTimeout(this.hoverTimeout[index].timeoutId);
                
        //         this.hoverTimeout.splice(index, 1);
        //     }
        // }

        // private hoverParameter(objectId: string, fieldSetId: string){
        //     if(this.IsEditor && !this.hoverTimeout.find(u => u.key == objectId)){
        //         setTimeout(() => {
        //             Vue.nextTick(() => {
        //                 this.stopHoverFieldSet(fieldSetId);
        //             });
        //         }, 1500)

        //         this.hoverTimeout.push({timeoutId: setTimeout(() => {
        //             Vue.nextTick(() => {
        //                 this.isHoverParameter = true;
        //                 this.hoverTimeout.find(u => u.key == objectId).value = true;
        //             });
        //         }, 900), key: objectId, value: false});
        //     }
        // }

        // private stopHoverParameter(objectId: string){
        //     if(this.IsEditor && this.hoverTimeout.find(u => u.key == objectId)){
        //         let index = this.hoverTimeout.findIndex(u => u.key == objectId);
        //         clearTimeout(this.hoverTimeout[index].timeoutId);
                
        //         this.hoverTimeout.splice(index, 1);
        //         this.isHoverParameter = false;
        //     }
        // }

        private openChangeModal(parameter: Parameter){
            this.$emit('openParameterModal', parameter);
            console.log("Open Change Modal : ", parameter);
        }

        private changeParameter(object: FieldSet | Parameter){
            this.$emit('openParameterModal', object);
            console.log("Change Parameter", object);
        }	

        /**
         * Envoie l'action au composant ReportEditor
         * @param event 
         * @param target 
         */
        private emitDrop(event, target: any){
            this.$emit('drop', event, target.getClassName());
        }
    }
    </script>

    <style scoped>
        :deep(input[type=checkbox]:checked) {
            /** Change la couleur de la checkbox */
            accent-color: var(--Variant) !important;
        }

        :deep(input[type=radio]:checked) {
            /** Change la couleur du bouton radio */
            accent-color: var(--Variant) !important;
        }

        /** Pour que la page active prenne en compte la couleur de Variant */
        :deep(.page-item.active .page-link) {
            background-color: var(--Variant) !important;
        }

        :deep(.page-link:hover) {
            background-color: var(--VariantLight) !important;
        }

        :deep(.form-check-input) {
            margin-top: 0.1rem !important; /* Ajustez pour centrer la checkbox */
        }

        .ghostFieldSet{
            border: 2px dashed #222 !important;
            height: 25%;
            background-color: gray;
            opacity: 0.2;
        }

        .selectedGhostFieldSet{
            background-color: green;
        }
    </style>

